module.exports = __webpack_public_path__ + "img/interface_er.c98422ba.png";